import { guardInstance } from "./util";

type ElementIterable = Array<Element> | NodeListOf<Element> | HTMLCollection;

export function addAttribute(elements: ElementIterable, attribute: string) {
  Array.from(elements).forEach((ele) => {
    ele.toggleAttribute(attribute, true);
  });
}

export function removeAttribute(elements: ElementIterable, attribute: string) {
  Array.from(elements).forEach((ele) => {
    ele.removeAttribute(attribute);
  });
}

export function addClass(elements: ElementIterable, className: string) {
  Array.from(elements).forEach((ele) => {
    ele.classList.add(className);
  });
}

export function removeClass(elements: ElementIterable, className: string) {
  Array.from(elements).forEach((ele) => {
    ele.classList.remove(className);
  });
}

export function setProperties(elements: ElementIterable, properties: Object) {
  Array.from(elements).forEach((ele) => {
    Object.assign(ele, properties);
  });
}

export function hideAll(elements: ElementIterable) {
  Array.from(elements).forEach((ele) => {
    ele.toggleAttribute("hidden", true);
  });
}

export function showAll(elements: ElementIterable) {
  Array.from(elements).forEach((ele) => {
    ele.removeAttribute("hidden");
  });
}

export function autofocus(element: HTMLElement, { preventScroll = false } = {}) {
  element.querySelector<HTMLElement>("[autofocus]")?.focus({ preventScroll });
}

export function traverseElements(root: HTMLElement, callback: { (element: HTMLElement): boolean }) {
  if (!callback.call(null, root)) {
    let childNodes: HTMLCollection | undefined;
    if (root instanceof HTMLTemplateElement) {
      childNodes = root.content.children;
    } else if (root instanceof HTMLIFrameElement) {
      childNodes = root.contentDocument?.children;
    } else {
      childNodes = root.children;
    }
    const childElements = Array.from(childNodes || []).filter(guardInstance(HTMLElement));
    childElements.forEach((child) => {
      traverseElements(child, callback);
    });
  }
}

export function templatizeHtml(html: string) {
  // <template> allows for HTML fragments (e.g. <tr> without a <table>), while DomParser and other elements do not
  const template = document.createElement("template");
  template.innerHTML = html;
  return template;
}

export function cloneElement<T extends Element>(ele: T): T {
  // https://github.com/microsoft/TypeScript/issues/283
  return ele.cloneNode(true) as T;
}
